import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineRentCreateApi extends BaseClient {
  public doMachineRentCreate (bodyData: {[key:string]: string|number|number[]}) {
    const path:string = '/v1/machine-rents'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new MachineRentCreateApi()
